import React, { Component } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';

import style from './style';


export default class StackCards extends Component {

	render() {
		return (
			<Card style={this.props.chef ? style.stackCardChef : style.stackCard}>
				<CardContent style={{ minHeight: '270px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', }}>
					<div className="home-img">
						<img src={this.props.image} title={this.props.title} alt={this.props.alt} />
					</div>
					<Typography variant="h5" style={style.stackCard}>
						<span style={this.props.step === "1" ? style.step1 : style.step}>{this.props.step}</span>
					</Typography>
					<Typography variant="h5" style={style.stackCardHeader} dangerouslySetInnerHTML={{
						__html: this.props.txtHeader
					}} />
					<Typography component="div" style={style.stackCard}>
						<br />
						{this.props.txtSub}
					</Typography>
				</CardContent>
			</Card>
		);
	}
}
